export const DEFAULT_ERROR_MSG = 'An error occurred';
